import { css } from "@microsoft/fast-element";
import { borderRadiusMedium, colorBrandBackground2, colorNeutralBackground1, colorNeutralBackground1Hover, colorNeutralBackground1Pressed, colorNeutralBackground1Selected, colorNeutralBackground2, colorNeutralBackground2Hover, colorNeutralBackground2Pressed, colorNeutralBackground2Selected, colorNeutralBackgroundDisabled, colorNeutralStroke1, colorNeutralStroke1Hover, colorNeutralStroke1Pressed, colorNeutralStroke1Selected, colorStrokeFocus2, colorSubtleBackground, colorSubtleBackgroundHover, colorSubtleBackgroundPressed, colorSubtleBackgroundSelected, colorTransparentBackground, colorTransparentBackgroundHover, colorTransparentBackgroundPressed, colorTransparentBackgroundSelected, colorTransparentStroke, colorTransparentStrokeDisabled, colorTransparentStrokeInteractive, fontFamilyBase, shadow2, shadow4, shadow8, strokeWidthThick, strokeWidthThin, display } from "@fluentui/web-components";
/** Card styles
 * @public
 */
export const styles = css `
  ${display("inline-block")}
  :host {
    font-family: ${fontFamilyBase};
    background: ${colorTransparentBackground};
    border-radius: ${borderRadiusMedium};
    position: relative;
    max-width: 100%;
    height: fit-content;
    overflow: hidden;
    box-shadow: ${shadow4};
    box-sizing: border-box;
    width: var(--card-width, 320px);
    height: var(--card-height, fit-content);
    z-index: var(--card-elevation, 1);
    flex-shrink: 0;
  }
  .card:focus-visible::after {
    content: "";
    position: absolute;
    inset: -1px;
    border-color: ${colorBrandBackground2};
    outline: ${strokeWidthThick} solid ${colorTransparentStroke};
    box-shadow:
      ${shadow4},
      0 0 0 2px ${colorStrokeFocus2};
  }
  .control {
    position: absolute;
    z-index: 2;
    top: 5px;
    inset-inline-end: 5px;
  }
  .content {
    display: grid;
    padding: var(--card-padding, 0);
  }
  .card {
    background: ${colorNeutralBackground1};
    border: ${strokeWidthThin} solid ${colorTransparentStroke};
    border-radius: ${borderRadiusMedium};
  }
  :host([orientation="horizontal"]) .content {
    grid-template-rows: unset;
    row-gap: unset;
    grid-template-columns: auto 1fr;
    align-items: center;
  }
  :host([appearance="filled-alternative"]) .card {
    background: ${colorNeutralBackground2};
  }
  :host([appearance="outline"]) {
    box-shadow: none;
  }
  :host([appearance="outline"]) .card {
    background: ${colorTransparentBackground};
    border-color: ${colorNeutralStroke1};
    box-shadow: none;
  }
  :host([appearance="subtle"]) .card {
    background: ${colorSubtleBackground};
    border-color: ${colorTransparentStroke};
    box-shadow: none;
  }
  :host([interactive]) {
    cursor: pointer;
    user-select: none;
  }
  :host([interactive]:hover) .card {
    background: ${colorNeutralBackground1Hover};
    border-color: ${colorTransparentStrokeInteractive};
    box-shadow: ${shadow8};
  }
  :host([interactive]:active) .card {
    background: ${colorNeutralBackground1Pressed};
    border-color: ${colorTransparentStrokeInteractive};
  }
  :host([interactive][appearance="filled-alternative"]:hover) .card {
    background: ${colorNeutralBackground2Hover};
  }
  :host([interactive][appearance="filled-alternative"]:active) .card {
    background: ${colorNeutralBackground2Pressed};
  }
  :host([interactive][appearance="outline"]:hover) .card {
    background: ${colorTransparentBackgroundHover};
    border-color: ${colorNeutralStroke1Hover};
    box-shadow: none;
  }
  :host([interactive][appearance="outline"]:active) .card {
    background: ${colorTransparentBackgroundPressed};
    border-color: ${colorNeutralStroke1Pressed};
  }
  :host([interactive][appearance="subtle"]:hover) .card {
    background: ${colorSubtleBackgroundHover};
    border-color: ${colorTransparentStrokeInteractive};
    box-shadow: none;
  }
  :host([interactive][appearance="subtle"]:active) .card {
    background: ${colorSubtleBackgroundPressed};
  }
  .card[aria-selected="true"] {
    background: ${colorNeutralBackground1Selected};
    border-color: ${colorTransparentStrokeInteractive};
    cursor: pointer;
  }
  :host([appearance="subtle"]) .card[aria-selected="true"] {
    background: ${colorSubtleBackgroundSelected};
    border-color: ${colorNeutralStroke1Selected};
  }
  :host([appearance="outline"]) .card[aria-selected="true"] {
    background: ${colorTransparentBackgroundSelected};
    border-color: ${colorNeutralStroke1Selected};
  }
  :host([appearance="filled-alternative"]) .card[aria-selected="true"] {
    background: ${colorNeutralBackground2Selected};
  }
  :host([aria-disabled="true"]) .card {
    background: ${colorNeutralBackgroundDisabled};
    border-color: ${colorTransparentStrokeDisabled};
    cursor: not-allowed;
    pointer-events: none;
    box-shadow: ${shadow2};
  }
  :host([appearance="subtle"]) .card[aria-disabled="true"],
  :host([appearance="outline"]) .card[aria-disabled="true"] {
    box-shadow: none;
  }
  :host([appearance="outline"]) .card[aria-disabled="true"] {
    background: ${colorTransparentBackground};
  }
`;
//# sourceMappingURL=card.styles.js.map